var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start space-x-2 text-red-500 bg-red-100 border border-red-300 rounded"},[_c('svg-alert'),_c('span',{staticClass:"text-sm"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }